import { createComponentProgrammatic } from '@/helpers/createComponentProgrammatic'
import { PublicationModel as Model } from './Model'

export const MODULE_NAME = 'collector-publications'

export const createModule = (moduleName: string, model: any) => {
  const ROUTES = {
    LAYOUT: moduleName,
    LIST: `${moduleName}.list`,
    VIEW: `${moduleName}.view`,
    EDIT: `${moduleName}.edit`,
    CREATE: `${moduleName}.create`,
  } as const

  const MENU = {
    id: ROUTES.LAYOUT,
    route: { name: ROUTES.LAYOUT },
    label: model.page_title.list,
    icon: 'mdi-book-open-blank-variant',
  } as const

  return { ROUTES, MENU }
}

export const COLLECTOR_PUBLICATIONS_MODULE = createModule(MODULE_NAME, Model)
export const COLLECTOR_PUBLICATIONS_ROUTES = COLLECTOR_PUBLICATIONS_MODULE.ROUTES
export const { MENU } = COLLECTOR_PUBLICATIONS_MODULE

export const createPermissionsGroupsCopyAteModal = (
  parent: unknown,
  propsData: Record<string, unknown>,
) => {
  const AsyncComponent = import(
    /* webpackChunkName: "UploadCollectorFileModal" */
    './components/UploadCollectorFileModal.vue'
  )

  const result = createComponentProgrammatic(
    AsyncComponent,
    parent,
    propsData,
  )

  return result
}

export const createImportKimsModal = (parent: Vue, propsData: unknown) => {
  const AsyncComponent = import(
    /* webpackChunkName: "CollectorPublicationImportKimsModal" */
    './components/CollectorPublicationImportKimsModal.vue'
  )

  const result = createComponentProgrammatic(
    AsyncComponent,
    parent,
    propsData,
  )

  return result
}
